module.exports = __webpack_public_path__ + "img/ic-scale-outline.3871a181.svg";